import routeFactory from '../../../../common/util/routeFactory';

export const crmManagementRoutes = {
  customerCrmInvestorFirms: routeFactory.customerCrmInvestorFirms.routePath,
  customerCrmSalesCoverage: routeFactory.customerCrmSalesCoverage.routePath,
  customerCrmFilesUpload: routeFactory.customerCrmFilesUpload.routePath,
  sysAdminCrmInvestorFirms: routeFactory.sysAdminCrmInvestorFirms.routePath,
  sysAdminCrmSalesCoverage: routeFactory.sysAdminCrmSalesCoverage.routePath,
  sysAdminCrmFilesUpload: routeFactory.sysAdminCrmFilesUpload.routePath,
};

export type CRMManagementRouteName = keyof typeof crmManagementRoutes;
